export type CalloutProperties = {
  id: MerchandisingTagType
  value: string
  skin: CalloutSkin
  variant?: CalloutVariant
}
export type CalloutSkin =
  | 'standard'
  | 'announcement'
  | 'foil'
  | 'holiday'
  | 'error'
  | 'new'
  | 'accent'
  | 'discount'
  | 'info'
  | 'warning'
  | 'success'
  | 'help'
  | 'promo'
  | null

export type CalloutVariant = 'standard' | 'overlay' | 'inverse'
export enum MerchandisingTagType {
  NEW = 'NEW',
  SUSTAINABLE = 'SUSTAINABLE',
  NEW_LOW_PRICE = 'NEW_LOW_PRICE',
  NEW_OPTIONS = 'NEW_OPTIONS',
  FREE_SAMPLES = 'FREE_SAMPLES',
  EXPRESS_SHIPPING = 'EXPRESS_SHIPPING',
}
export enum SupportedMerchandisingTagType {
  NEW_LOW_PRICE = 'NEW_LOW_PRICE',
  NEW = 'NEW',
  NEW_OPTIONS = 'NEW_OPTIONS',
}
export type CalloutEmphasis = 'standard' | 'low' | null

export const invalidCalloutTagTypes = [MerchandisingTagType.FREE_SAMPLES, MerchandisingTagType.EXPRESS_SHIPPING, MerchandisingTagType.SUSTAINABLE]

export const validMerchandisingTagTypes = Object.values(MerchandisingTagType).filter((tag) => !invalidCalloutTagTypes.includes(tag))

export type CalloutTagType = keyof typeof MerchandisingTagType
